<template>
  <div class="filter-container flex-row">
    <div class="filter-op">
      <ms-validate ref="validateObserver">
        <menu-wrapper>
          <template #menu-button="{ toggleMenu }">
            <button
              tabindex="-1"
              @click="toggleMenu"
              class="btn-filter-operator"
            >
              <div :class="['icon24', nativeFilterIconClass]"></div>
            </button>
          </template>
          <template #menu-content>
            <template v-for="(item, i) in filterOperators" :key="i">
              <menu-item
                class="filter-operator-item"
                :class="item.enumValue === operatorValue ? 'active' : ''"
                @menu-item-click="filterOperatorItemClick(item)"
                :icon="['icon24', item.icon]"
                >{{ item?.enumText }}</menu-item
              >
            </template>
          </template>
        </menu-wrapper>
      </ms-validate>
    </div>
    <div class="filter-value flex">
      <ms-input
        :readOnly="operatorValueReadonly"
        ref="filterInput"
        v-model="filterValue"
        class="w-full ms-input-filter-value"
        @keyup.enter="
          filterHeaderHandle({ operator: operatorValue, value: filterValue })
        "
        :hasBorder="false"
      />
    </div>
  </div>
</template>
<script>
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import { defineComponent, getCurrentInstance } from 'vue';
import msThOptionBase from '@/components/gridViewer/columnOption/MsThOptionBase.js';
import setup from '@/components/gridViewer/columnOption/render-helper.js';
import msValidate from '@/components/validate/MsValidate.vue';
export default defineComponent({
  name: 'MsThOptionText',
  extends: msThOptionBase,
  components: {
    msValidate,
    MenuItem,
    MenuWrapper,
  },
  props: {},
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    //Khai báo data variable
    const {
      nativeFilterIconClass,
      operatorValue,
      operatorValueReadonly,
      filterValue,
      filterInput,
      filterOperators,
      filterHeaderHandle,
      filterOperatorItemClick,
      removeFilter,
    } = setup(props, {
      emit,
    });
    //Method
    //Hooks
    const keyupHandler = (e) => {
      if (e.keyCode === proxy.$ms.constant.KeyCode.Enter) {
        filterHeaderHandle({ operator: operatorValue, value: filterValue });
      }
    };
    return {
      nativeFilterIconClass,
      filterInput,
      filterValue,
      operatorValue,
      operatorValueReadonly,
      filterOperators,
      filterOperatorItemClick,
      filterHeaderHandle,
      removeFilter,
      keyupHandler,
    };
  },
});
</script>
